import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/news";
import { formatViews } from "@/lib/news";

export default function HotSidebar({ items }: { items: NewsItem[] }) {
  return (
    <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
        <h2 className="flex items-center gap-1.5 font-heading text-lg font-bold text-foreground-900">
          <i className="ri-fire-fill text-accent-500"></i>
          热门新闻榜
        </h2>
      </div>
      <ul className="space-y-1">
        {items.map((news, i) => (
          <li key={news.id}>
            <Link
              to={`/detail/${news.id}`}
              className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                  i < 3 ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-600"
                }`}
              >
                {i + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                  {news.title}
                </span>
                <span className="mt-1 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatViews(news.views)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-thumb-up-line"></i>
                    {formatViews(news.likes)}
                  </span>
                </span>
              </span>
              <span className="hidden h-14 w-20 shrink-0 overflow-hidden rounded-md bg-background-200 sm:block">
                <img
                  src={news.cover}
                  alt={`${news.title} - 91爆料热门新闻`}
                  title={`${news.title} - 91爆料`}
                  className="h-14 w-20 object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}